import { AddressActionTypes } from "../actions/types";
import { AddressActions } from "../actions/address.actions";
import { initialState } from "../reducers/root.reducer";
import {Address} from "../../components/AddressSelector/Address";

export const addressReducer = (
    state: Address = initialState.address,
    action: AddressActions
) => {
    switch (action.type) {
        case AddressActionTypes.ADD_ADDRESS:
            return action.payload;
        default:
            return state;
    }
};
